module.exports = "/images/logo.svg?2d435cda677bd1b3241b81e1607c58c9";